import React, { Component } from "react";
import Routes from "./routes";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-datepicker/dist/react-datepicker-min.module.css';

import './App.css';
import theme from 'theme';
import apiLogin from "services/structure/apiLogin";
import { loadLayoutAction }  from 'services/ducks/layout';
import { isDesktop, isTablet } from "react-device-detect";

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

class App extends Component {

    state = {
        imageUrl: "",
        cssUrl: ""
    }

    constructor() {
        super();
        this.loadLayout();
    }

    loadLayout = async () => {
        const response = await apiLogin.get("/layout");
        window.scrollTo(0, 0);
        if (response.data) {
            this.props.loadLayoutAction({ 
                imageLogoUrl: response.data.imageUrl,
                cssUrl: response.data.cssUrl,
                descricao: response.data.descricao,
                tenant: response.data.tenant
            });
            return;
        }
    }

    render() {

        const { cssUrl } = this.props;
        const noTabletBodyCss = `
            body {
                background-repeat: no-repeat;
                background-size: cover;
            }`// TODO: parametrizar no endpoint
        const desktopHtmlCss = `
            html {
                min-width: 1280px;
            }
        `

        return (
                <StylesProvider injectFirst>
                    <CssBaseline />
                    {
                        !!cssUrl &&
                        <style>
                            @import url('{cssUrl}')
                        </style>
                    }
                    {
                        !isTablet && 
                        <style>{noTabletBodyCss}</style>
                    }
                    {
                        isDesktop && 
                        <style>{desktopHtmlCss}</style>
                    }
                    <ThemeProvider theme={theme}>
                        <Routes />
                    </ThemeProvider>
                </StylesProvider>
        )
    }
}
const mapStateToProps = store => ({
    cssUrl: store.layoutState.cssUrl
  });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ loadLayoutAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);